import { ElementType } from "react";
import classNames from "classnames";
import Error from "@easydev/form/Error";
import MaskedInput from "react-text-mask";

interface IFormTextField {
  input: any;
  meta: {
    touched: boolean;
    error: string;
  };
  Component: ElementType;
  isAboveError: boolean;
  wrapperClassName: string;
}

const FormField = ({
  input = null,
  meta: { touched = false, error = "" },
  Component = "input",
  isAboveError = false,
  wrapperClassName = "",
  ...props
}: IFormTextField) => (
  <div
    className={classNames(
      "form__form-group-input-wrap",
      { "form__form-group-input-wrap--error-above": isAboveError },
      wrapperClassName
    )}
  >
    <Component {...props} {...input} />
    {touched && error && <Error error={error} />}
  </div>
);

export const renderComponentField = (component: ElementType) => (props: any) =>
  <FormField component={component} {...props} />;

export const renderMaskedField = renderComponentField(MaskedInput);

export default FormField;
